import { render, staticRenderFns } from "./LoadingDemo.vue?vue&type=template&id=5e1705fd&scoped=true"
import script from "./LoadingDemo.vue?vue&type=script&lang=js"
export * from "./LoadingDemo.vue?vue&type=script&lang=js"
import style0 from "./LoadingDemo.vue?vue&type=style&index=0&id=5e1705fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1705fd",
  null
  
)

export default component.exports